<div class="wrapper">
	<img src="assets/images/source/{{ source }}"/>
</div>